import React from 'react';
import imageUrl from 'assets/images/Sales_Order.png';
import { Typography } from '../../../node_modules/@mui/material/index';
import { useLocation, useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { FABRICUSER, GARMENTUSER } from 'utils/constants';
import { fetchSampleRequestBarcodesData } from 'Service/ApiService';
import { showAlert } from 'utils/ErrorMessage';

// const customer = JSON.parse(localStorage.getItem('headerCustomer'));
const SampleRequestDashboard = () => {
  const [isData, setIsData] = React.useState(false);
  const [isClick, setClick] = React.useState(false);
  const [designNumber, setDesignNumber] = React.useState('');
  const [designError, setDesignError] = React.useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const addMoreDraft = location.state?.addMoreDraft || null;
  const handleDivClick = (value) => () => {
    if (value == 'design') {
      setClick(true);
    } else {
      sendNav();
    }
  };
  const handleCloseDialog = () => {
    if (!isData) {
      setClick(false);
      setDesignNumber('');
      setDesignError('');
    }
  };

  const handleOk = async () => {
    if (!designNumber.trim()) {
      setDesignError('Design Number is required');
      return;
    }

    try {
      setIsData(true);
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const response = await fetchSampleRequestBarcodesData(
        user.userId,
        '',
        user.userCode,
        user.userVerticalId,
        '',
        designNumber.trim()
      );

      if (response?.success !== 'true' || !Array.isArray(response?.materialList) || response.materialList.length === 0) {
        showAlert(response?.msg || 'No Data Found!', 'No Data');
        return;
      }

      let nextData = response.materialList;
      const nextState = { barcodeData: nextData };

      if (addMoreDraft) {
        const existingData = Array.isArray(addMoreDraft.barcodeData) ? addMoreDraft.barcodeData : [];
        const existingBarcodes = new Set(existingData.map((item) => String(item?.barcode || '')).filter(Boolean));
        nextData = response.materialList.filter((item) => {
          const barcode = String(item?.barcode || '');
          return !barcode || !existingBarcodes.has(barcode);
        });
        Object.assign(nextState, {
          barcodeData: [...nextData, ...existingData],
          selectedCustomer: addMoreDraft.selectedCustomer || null,
          sampleCategory: addMoreDraft.sampleCategory || null,
          isReplication: Boolean(addMoreDraft.isReplication),
          isEditMode: Boolean(addMoreDraft.isEditMode),
          sampleRequestReplicateRefNo: addMoreDraft.sampleRequestReplicateRefNo || '',
          sampleRequestOrderId: addMoreDraft.sampleRequestOrderId || '',
          sampleRequestDocNo: addMoreDraft.sampleRequestDocNo || '',
          remark: addMoreDraft.remark || '',
          hasUnsavedChanges: true,
          returnToSampleRequestList: true
        });
      }

      navigate('/sample-request-selection', { replace: Boolean(addMoreDraft), state: nextState });
    } catch (error) {
      showAlert(error?.message || 'Unable to load design materials.');
    } finally {
      setIsData(false);
      setClick(false);
      setDesignNumber('');
      setDesignError('');
    }
  };
  
  const handleDivKeyPress = (value) => (event) => {
    if (event.key === 'Enter') {
      if (value == 'design') {
        setClick(true);
      } else {
        sendNav();
      }
    }
  };
  const sendNav = () => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const userVerticalId = String(user?.userVerticalId || '');

    if (!userVerticalId) {
      navigate('/login', { replace: true });
      return;
    }

    if (userVerticalId == FABRICUSER) {
      navigate('/sample-request-barcode-scan', { replace: Boolean(addMoreDraft), state: { addMoreDraft } });
    } else if (userVerticalId.toLowerCase().includes(GARMENTUSER.toLowerCase())) {
      navigate('/sample-request-barcode-scan', { replace: Boolean(addMoreDraft), state: { addMoreDraft } });
    }
  };
  return (
    <div className="bg" style={{ display: 'block' }}>
      <div className="cutrange">
        <span className="font20">SAMPLE REQUEST DASHBOARD</span>
      </div>

      <div>
        <div style={{ paddingBottom: '20px' }} className="horizontal-center">
          <div className="flexWrapper-d">
            <div
              style={{ width: '150px' }}
              className="card-subtitle"
              onClick={handleDivClick('design')}
              onKeyDown={handleDivKeyPress('design')}
              role="button"
              tabIndex={0}
            >
              <div style={{ padding: '10px' }} className="horizontal-center">
                <div>
                  <div className="horizontal-center">
                    <img src={imageUrl} alt="Design No Entry" style={{ width: 'auto' }} />
                  </div>
                  <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                    Design No Entry
                  </Typography>
                </div>
              </div>
            </div>
            <div
              style={{ width: '150px' }}
              className="card-subtitle"
              onClick={handleDivClick('/sample-request-barcode-scan')}
              onKeyDown={handleDivKeyPress('/sample-request-barcode-scan')}
              role="button"
              tabIndex={0}
            >
              <div style={{ padding: '10px' }} className="horizontal-center">
                <div>
                  <div className="horizontal-center">
                    <img src={imageUrl} alt="Barcode Scan" style={{ width: 'auto' }} />
                  </div>
                  <Typography variant="subtitle1" style={{ marginTop: '10px' }}>
                    Barcode Scan
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Design Number Dialog kept in this page */}
      <Dialog open={isClick} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Enter Design Number</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <TextField
              autoFocus
              fullWidth
              label="Design Number"
              variant="outlined"
              value={designNumber}
              onChange={(e) => { setDesignNumber(e.target.value); if (designError) setDesignError(''); }}
              onKeyDown={(e) => { if (e.key === 'Enter') handleOk(); }}
              helperText={designError}
              error={!!designError}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={isData}>Cancel</Button>
          <Button variant="contained" onClick={handleOk} disabled={isData}>
            {isData ? <CircularProgress size={20} color="inherit" /> : 'OK'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SampleRequestDashboard;
